module.exports = __webpack_public_path__ + "img/PFD.758ba45d.png";